export default class extends Controller {
  connect(){
    $(this.element).select2({
      dropdownParent: this.element.closest('.modal'),
    })
  }
}
